import axios from 'axios';
import Vue from 'vue'
import i18n from "@/i18n";

export default {
    
    saveAnnouncment(fd){
        return axios.post('/api/announcment/save', fd)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.announcement.saveAnnouncment'));
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    editAnnouncement(anouncement){
        return axios.post('/api/announcment/edit', anouncement)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.announcement.saveAnnouncment'));
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAnnouncments (page, pageSize) {
        return axios.get('/api/announcment/list', { params: {page: page, pageSize: pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeAnnouncement(announcement){
        return axios.post("/api/announcment/remove/",announcement)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.announcement.removeAnnouncement'));
                 return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    uploadAnnouncementImage(formData,id) {
        return axios.post("/api/announcment/upload/"+id, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(response => {
                if (response && response.data) {
                    Vue.prototype.$snotify.success(i18n.t('services.announcement.uploadAnnouncementImage'));
                    return response.data;
                }
            })
            .catch(error => { Vue.prototype.$snotify.error(error); })
    },

    getPromotionsAndNews (page, pageSize) {
        return axios.get('/api/announcment/promotionsAndNews', { params: {page: page, pageSize: pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getHighlights (page, pageSize) {
        return axios.get('/api/announcment/highlights', { params: {page: page, pageSize: pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


}